import axios from "axios";
import { error_handle } from "../helpers/error";
class access_counting {

    count(side) {
        return axios.request({
            url: '/counting/count?side=' + side,
            method: 'get',
        })

            .then(response => {
                console.log(response);
            })

            .catch((error) => {
                console.log(error);
            })

    }

    add(data, loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/add',
            method: 'post',
            data: data
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }

    get(filter, loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/get',
            method: 'get',
            params: filter
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }

    getMapping(loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/getMapping',
            method: 'get',
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }

    edit(data, loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/edit',
            method: 'put',
            data: data
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }

    delete(data, loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/delete',
            method: 'delete',
            data: data
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }

    filter(filter=null, fields=null, sort=null, skip=null, limit=null , loading=true) {
        loading&&window.loading(true)
        return axios.request({
            url: '/counting/filter',
            method: 'post',
            data: {
                filter,
                fields,
                sort,
                skip,
                limit
            }
        })

            .then(response => {
                loading&&window.loading(false)
                response = response['data'];
                if(response['result']){
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                loading&&window.loading(false)
                error_handle(error)
            })

    }



}

export default access_counting